var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPathways(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pathways",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 44,
    height: 44,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(3.667 5.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M9.333,25a3.667,3.667,0,1,1-3.667,3.667A3.677,3.677,0,0,1,9.333,25m0-3.667a7.333,7.333,0,1,0,7.333,7.333A7.355,7.355,0,0,0,9.333,21.333Zm11-14.667a3.667,3.667,0,1,1-3.667,3.667,3.677,3.677,0,0,1,3.667-3.667m0-3.667a7.333,7.333,0,1,0,7.333,7.333A7.355,7.355,0,0,0,20.333,3Zm11,22a3.667,3.667,0,1,1-3.667,3.667A3.677,3.677,0,0,1,31.333,25m0-3.667a7.333,7.333,0,1,0,7.333,7.333A7.355,7.355,0,0,0,31.333,21.333Z",
    transform: "translate(-2 -3)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 25.667,
    height: 3.667,
    transform: "translate(5.5 14.667)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 3.667,
    height: 7.333,
    transform: "translate(16.5 11)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 3.667,
    height: 5.5,
    transform: "translate(5.5 16.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 3.667,
    height: 5.5,
    transform: "translate(27.5 16.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathways);
export default __webpack_public_path__ + "static/media/pathways.9c898fc20d9ad9777a29c16251a11776.svg";
export { ForwardRef as ReactComponent };